import {
    CardBackgroundColor,
    Container,
    ContainerType,
    containerTypeOptions,
    ShadowCard,
    Spacer,
    spacerOptionsAll,
    SpacerVariant,
} from "../components/layout"
import { Repeater, types } from "react-bricks/frontend"
import Typography, { TypographyElement } from "../Typography"

import React from "react"
import { TextLinkBrickProps } from "./TextLink"

interface TextLinksShadowCardProps {
    text: TypographyElement[]
    type?: ContainerType
    spacerTop?: SpacerVariant
    spacerBottom?: SpacerVariant
}

const TextLinksShadowCard: types.Brick<TextLinksShadowCardProps> = ({
    type,
    spacerTop = SpacerVariant.Medium,
    spacerBottom = SpacerVariant.Medium,
}) => {
    return (
        <Container type={type}>
            <Spacer variant={spacerTop} />
            <ShadowCard className="space-y-6 lg:space-y-7" background={CardBackgroundColor.Grey} type={type}>
                <Typography allowList={["h5", "bold"]} />
                <div className="space-y-5 sm:space-y-7">
                    <Repeater
                        propName="repeater"
                        itemProps={
                            {
                                bold: true,
                                type: type,
                            } as TextLinkBrickProps
                        }
                    />
                </div>
            </ShadowCard>
            <Spacer variant={spacerBottom} />
        </Container>
    )
}

TextLinksShadowCard.schema = {
    name: "TextLinksShadowCard",
    label: "Text Links Card",
    previewImageUrl: `${process.env.IMG_CDN_URL_ASSETS}/lavita.de/startseite/screenshots_bricks/TextLinksShadowCard.png`,
    repeaterItems: [
        {
            name: "repeater",
            items: [
                {
                    type: "TextLink",
                    label: "Text Link",
                    min: 1,
                },
            ],
        },
    ],
    sideEditProps: [
        {
            name: "type",
            label: "Type",
            type: types.SideEditPropType.Select,
            selectOptions: {
                options: containerTypeOptions,
                display: types.OptionsDisplay.Radio,
            },
        },
        {
            groupName: "Spacer",
            props: [
                {
                    name: "spacerTop",
                    label: "Spacer Top",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
                {
                    name: "spacerBottom",
                    label: "Spacer Bottom",
                    type: types.SideEditPropType.Select,
                    selectOptions: {
                        options: spacerOptionsAll,
                        display: types.OptionsDisplay.Select,
                    },
                },
            ],
        },
    ],
    getDefaultProps: (): TextLinksShadowCardProps => ({
        text: [
            {
                type: "h4",
                children: [
                    {
                        text: "Lorem ipsum dolor sit amet, consetetur sadipscing elitr, sed diam nonumy eirmod tempor invidunt:",
                        bold: true,
                    },
                ],
            },
        ],
        spacerTop: SpacerVariant.Medium,
        spacerBottom: SpacerVariant.Medium,
    }),
}

export default TextLinksShadowCard
